import React, { useState, useEffect, forwardRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { formatDateWbar } from "../../../../components/Util/DateFormat";
import "./BbsVoteDetail.css";
import "./swalStyle.css";
import { ko } from "date-fns/esm/locale";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-regular-svg-icons";
import { faSquareMinus } from "@fortawesome/free-regular-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import Comments from "../../../../components/Comments/Comment";
import CommentForm from "../../../../components/Comments/CommentForm";
import CommentList from "../../../../components/Comments/CommentList";
import { getServerBaseUrl } from "../../../../utils/portConfig";

function BbsVoteDetail({ whenMovingNoticeDetail, bbsDate }) {
  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");
  const [isEnable, setIsEnable] = useState(true);
  const [voteInfoData, setVoteInfoData] = useState({});
  const [voteDetailList, setVoteDetailList] = useState([]);
  const [userSelectedList, setUserSelectedList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // 라디오 버튼 선택
  const [voteList, setVoteList] = useState([]); //투표하기
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isUsersVotes, setIsUsersVotes] = useState(false);
  const [modifyButtonText, setModifyButtonText] = useState("수정");
  const [voteButtonText, setVoteButtonText] = useState("투표하기");
  const [reVote, setReVote] = useState(false);
  const [isToggledDoubleCheck, setToggledDoubleCheck] = useState(false); //복수선택
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [checkedOptions, setCheckedOptions] = useState([]);
  const [totalVoter, setTotalVoter] = useState(0);
  const [commentState, setCommentState] = useState({ list: [] });

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/vote`;
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userid");

  const titleChange = (e) => {
    const { name, value } = e.target;
    setVoteInfoData({
      ...voteInfoData,
      [name]: value,
    });
  };

  const [totalParticipatedUsers, setTotalParticipatedUsers] = useState(0);
  // 사용자 수 및 각 옵션의 게이지 계산
  useEffect(() => {
    if (userSelectedList) {
      const uniqueUserIds = Array.from(new Set(userSelectedList.map((user) => user.userId)));
      setTotalParticipatedUsers(uniqueUserIds.length);

      // 각 옵션의 게이지 계산 및 업데이트
      voteDetailList.forEach((option, index) => {
        const optionElement = document.getElementById(option.id);
        if (optionElement) {
          const gaugeFillElement = optionElement.querySelector(".vote-gauge-fill");
          if (gaugeFillElement) {
            const optionPercentage = (option.cnt / uniqueUserIds.length) * 100;
            gaugeFillElement.style.width = `${optionPercentage}%`;
          }
        }
      });
    }
  }, [userSelectedList, voteDetailList]);

  //투표 조회
  const getVoteDetails = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/${whenMovingNoticeDetail}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });

      if (response.status === 200) {
        if (response.data.voteDTO.userId === userid) {
          setIsUsersVotes(true);
        }
        if (response.data.userSelectedList.length !== 0 && response.data.userSelectedList.some((user) => user.userId === userid)) {
          setReVote(true);
          setVoteButtonText("다시투표하기");
          const extractedIds = response.data.userSelectedList.map((item) => item.voteDetailId);
          setSelectedOption(extractedIds[0]);
        }
        setTotalVoter(response.data.totalVoter);
        setVoteInfoData(response.data.voteDTO);
        setVoteDetailList(response.data.voteDetailList);
        setUserSelectedList(response.data.userSelectedList);
        setToggledDoubleCheck(response.data.voteDTO.multipleChoice);
        setIsEnable(response.data.voteDTO.enabled);
        setStartDate(new Date(response.data.voteDTO.startDate));
        setEndDate(new Date(response.data.voteDTO.endDate));
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "투표 조회 실패. 다시 시도해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("투표 조회 에러:", error);
    }
  };

  useEffect(() => {
    if (whenMovingNoticeDetail) {
      voteInfoData.id = whenMovingNoticeDetail;
      getVoteDetails();
    }
  }, [whenMovingNoticeDetail]);

  // 투표 항목 수정 시 호출되는 핸들러
  const handleVoteOptionChange = (e, index) => {
    const { value } = e.target;
    setVoteDetailList((prevList) => prevList.map((item, i) => (i === index ? { ...item, content: value } : item)));
  };

  // 투표 수정 - 옵션 추가
  const addOption = () => {
    setVoteDetailList((prevList) => [...prevList, { content: "", voteId: voteInfoData.id, cnt: 0 }]);
  };

  // 투표 수정 - 옵션 삭제
  const removeOption = (index) => {
    setVoteDetailList((prevList) => prevList.filter((_, i) => i !== index));
  };

  // 투표 옵션
  const renderVoteOptions = () => {
    if (modifyButtonText === "수정") {
      return voteDetailList.map((option, index) => (
        <label
          key={index}
          className={`${isEnable ? "options-list" : "options-list-ended"} ${userSelectedList.some((user) => Number(user.voteDetailId) === Number(option.id)) ? "user-vote-selected" : ""}`}
          htmlFor={option.id}
        >
          <div className="option-container">
            {isEnable && voteButtonText !== "다시투표하기" && (
              <input
                type={!voteInfoData.multipleChoice ? "radio" : "checkbox"}
                id={option.id}
                checked={!voteInfoData.multipleChoice ? Number(selectedOption) === Number(option.id) : checkedOptions.includes(option.id)}
                name={option.voteId}
                onChange={() => handleCheckboxChange(!voteInfoData.multipleChoice ? "radio" : "checkbox", option.id)}
              />
            )}
            <div className="option-container">{option.content}</div>
          </div>
          <div>
            <span className="option-people-icon-size">
              <FontAwesomeIcon icon={faUser} />
              &nbsp;{option.cnt}
            </span>
          </div>
        </label>
      ));
    } else {
      return voteDetailList.map((option, index) => (
        <div className="voting-container">
          <ul className="vote-contents-align">
            {voteDetailList.length < 5 && (
              <li className="vote-add-button">
                <FontAwesomeIcon className="icon-size icon-plus-background" icon={faSquarePlus} onClick={addOption} />
              </li>
            )}
            <li className="vote-contents-input" key={index}>
              <input type="text" name="content" value={option.content} onChange={(e) => handleVoteOptionChange(e, index)} />
            </li>
            {voteDetailList.length > 1 && (
              <li className="vote-minus-button">
                <FontAwesomeIcon className="icon-size icon-minus-background" icon={faSquareMinus} onClick={() => removeOption(index)} />
              </li>
            )}
          </ul>
        </div>
      ));
    }
  };

  // 투표 설정
  const renderVoteSettings = () => {
    if (modifyButtonText === "수정") {
      return (
        <>
          {/*.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')*/}
          {startDate !== null && endDate !== null && (
            <div className="vote-deadline vote-left-align">
              {" "}
              마감일: {formatDateWbar(new Date(startDate))} ~ {formatDateWbar(new Date(endDate))}
            </div>
          )}
          <div className="vote-multiChoice vote-left-align">{!voteInfoData.multipleChoice ? "단일선택" : "복수선택"}</div>
        </>
      );
    } else {
      return (
        <>
          <div className="voting-settings-option" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div className="settings-option-fonts">
              <FontAwesomeIcon icon={faClock} />
              &nbsp;&nbsp;<span>마감일 설정</span>
            </div>
          </div>
          <div className="deadline-hidden-container">
            <div className="startDate-datepicker">
              <span>
                <FontAwesomeIcon icon={faCalendarDays} />
                &nbsp;시작
              </span>
              <DatePicker
                name="startDate"
                locale={ko}
                selected={startDate}
                dateFormat="yyyy-MM-dd"
                onChange={(date) => setStartDate(date)}
                customInput={<CustomDatePickerInput />}
                minDate={new Date()}
              />
            </div>
            <span style={{ fontSize: "15px" }}>~</span>
            <div className="endDate-datepicker">
              <span>
                <FontAwesomeIcon icon={faCalendarDays} />
                &nbsp;마감
              </span>
              <DatePicker
                name="endDate"
                locale={ko}
                selected={endDate}
                dateFormat="yyyy-MM-dd"
                onChange={(date) => setEndDate(date)}
                customInput={<CustomDatePickerInput />}
                minDate={new Date(startDate)}
              />
            </div>
          </div>
          <div className="voting-settings-option" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <div className="settings-option-fonts">
              <FontAwesomeIcon icon={faCheckDouble} />
              &nbsp;&nbsp;<span>복수 선택</span>
            </div>
            <div>
              <div className={`toggle-slider ${isToggledDoubleCheck ? "toggled" : ""}`} onClick={handleToggleDoubleCheck}>
                <div className="slider"></div>
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  const handleCheckboxChange = (typeName, optionId) => {
    if (typeName === "checkbox") {
      // 체크박스의 상태가 변경될 때마다 호출되는 메소드
      // optionId가 이미 checkedOptions에 있으면 제거, 없으면 추가
      setCheckedOptions((prevCheckedOptions) => {
        if (prevCheckedOptions.includes(optionId)) {
          return prevCheckedOptions.filter((id) => id !== optionId);
        } else {
          return [...prevCheckedOptions, optionId];
        }
      });
    } else if (typeName === "radio") {
      setSelectedOption(optionId);
    }
  };

  useEffect(() => {
    if (voteList) {
      console.log("updated voteList:", voteList);
    }
  }, [voteList]);

  // 디바운싱 적용- 투표하기 axios
  const debouceVoteFunction = useCallback(
    debounce(async (voteList, flag) => {
      try {
        const response = await axios.post(`${API_SERVER_URL}/${Number(whenMovingNoticeDetail)}/saveVote/${userId}`, voteList, { headers: { Authorization: `Bearer ${token}` } });

        if (response.status === 201 || response.status === 200) {
          if (flag === "투표") {
            Swal.fire({
              icon: "success",
              title: "성공",
              text: "투표했습니다.",
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }

          //Swal.fire가 완료된 후에 상태 변경
          getVoteDetails();
          setReVote(true);
          setVoteButtonText("다시투표하기");
        } else {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "투표 실패. 다시 시도해주세요.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } catch (error) {
        console.error("Error Voting:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "투표 오류",
              text: responseData,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    }, 1000),
    [reVote, token, whenMovingNoticeDetail, getVoteDetails]
  );

  // 투표하기
  const vote = (flag) => {
    if (voteButtonText === "투표하기") {
      const checkedOptions = voteDetailList.filter((option) => {
        const element = document.getElementById(option.id);
        return element && element.checked;
      });

      if (checkedOptions.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "알림",
          text: "투표옵션을 선택해주세요",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
        return;
      }

      setVoteList((prevVoteList) => {
        // 중복 체크 및 새로운 값 추가
        const newList = checkedOptions.reduce((acc, option) => {
          const isDuplicate = acc.some((existingOption) => existingOption.voteDetailId === option.id && existingOption.userId === userid);

          if (!isDuplicate) {
            acc.push({
              voteId: option.voteId,
              voteDetailId: option.id,
              userId: userid,
            });
          }

          return acc;
        }, []);

        debouceVoteFunction(newList, flag);

        return newList;
      });
    } else {
      const checkUser = userSelectedList.filter((user) => user.userId === userid);

      checkUser.forEach((selectedUser) => {
        const selectedOption = voteDetailList.find((option) => Number(option.id) === Number(selectedUser.voteDetailId));
        if (selectedOption) {
          setCheckedOptions((prevCheckedOptions) => [...prevCheckedOptions, selectedOption.id]);
        }
      });

      setReVote(false);
      setVoteButtonText("투표하기");
    }
  };

  const movingNoticePage = () => {
    const setTabFlag = "투표목록";
    navigate("/", { state: { setActiveMenu: "게시판", tabFlag: setTabFlag } });
  };

  const movingVisualizationPage = () => {
    navigate("/", { state: { setActiveMenu: "게시판", tabFlag: "투표그래프", data: voteDetailList, setBbsDate: bbsDate, setTitle: voteInfoData.title } });
  };

  // 복수선택 슬라이더
  const handleToggleDoubleCheck = () => {
    setToggledDoubleCheck(!isToggledDoubleCheck);
  };

  const CustomDatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <button className="custom-datepicker-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  useEffect(() => {
    setVoteInfoData((prevVoteInfoData) => ({
      ...prevVoteInfoData,
      enabled: isEnable,
      startDate: startDate ? formatDateWbar(startDate) : "",
      endDate: endDate ? formatDateWbar(endDate) : "",
      multipleChoice: isToggledDoubleCheck,
    }));
  }, [isToggledDoubleCheck, startDate, endDate]);

  // 투표 수정버튼
  const modifyNotice = async () => {
    if (modifyButtonText === "저장") {
      const confirmationResult = await Swal.fire({
        icon: "question",
        title: "투표 수정",
        text: "투표를 수정하시겠습니까?",
        showCancelButton: true,
        confirmButtonText: "확인",
        cancelButtonText: "취소",
        customClass: {
          popup: "custom-swal-popup",
        },
      });

      if (confirmationResult.isConfirmed) {
        try {
          const response = await axios.put(
            `${API_SERVER_URL}/${voteInfoData.id}/update/${userId}`,
            {
              vote: {
                id: voteInfoData.id,
                title: voteInfoData.title,
                userId: voteInfoData.userId,
                regDate: voteInfoData.regDate,
                startDate: voteInfoData.startDate,
                endDate: voteInfoData.endDate,
                enabled: voteInfoData.enabled,
                deadline: voteInfoData.deadline,
                multipleChoice: voteInfoData.multipleChoice,
              },
              voteDetails: voteDetailList,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "성공",
              text: "투표가 수정되었습니다.",
              customClass: {
                popup: "custom-swal-popup",
              },
            }).then(() => {
              setIsReadOnly(true);
              setModifyButtonText("수정");
              setVoteInfoData({});
              setVoteDetailList([]);
              setUserSelectedList([]);
              getVoteDetails();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "실패",
              text: "투표 수정 실패. 다시 시도해주세요.",
              customClass: {
                popup: "custom-swal-popup",
              },
            }).then(() => {
              setIsReadOnly(false);
              setModifyButtonText("저장");
            });
          }
        } catch (error) {
          console.error("Error updating vote:", error);
          if (error.response) {
            const responseData = error.response.data;
            if (responseData) {
              Swal.fire({
                icon: "error",
                title: "투표 수정 오류",
                text: responseData,
                customClass: {
                  popup: "custom-swal-popup",
                },
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "서버 응답 오류",
                text: `서버 응답 오류: ${error.response.status}`,
                customClass: {
                  popup: "custom-swal-popup",
                },
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답이 없습니다.",
              text: "서버 응답이 없습니다.",
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        }
      } else if (!confirmationResult.isConfirmed) {
        setIsReadOnly(true);
        setModifyButtonText("저장");
      }
    }
    setIsReadOnly(!isReadOnly);
    setModifyButtonText(!isReadOnly ? "수정" : "저장");
  };

  // 투표 종료 버튼
  const endedVote = async () => {
    const confirmationResult = await Swal.fire({
      icon: "question",
      title: "투표 종료",
      text: "투표를 종료하시겠습니까? 종료하시면 투표 수정, 투표하기가 불가능합니다.",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (confirmationResult.isConfirmed) {
      try {
        vote("종료");
        const response = await axios.put(
          `${API_SERVER_URL}/${voteInfoData.id}/update/${userId}`,
          {
            vote: {
              id: voteInfoData.id,
              title: voteInfoData.title,
              userId: voteInfoData.userid,
              regDate: voteInfoData.regDate,
              startDate: voteInfoData.startDate,
              endDate: voteInfoData.endDate,
              enabled: false,
              deadline: voteInfoData.deadline,
              multipleChoice: voteInfoData.multipleChoice,
            },
            voteDetails: voteDetailList,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "성공",
            text: "투표가 종료되었습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          }).then(() => {
            setIsReadOnly(true);
            setVoteInfoData({});
            setVoteDetailList([]);
            setUserSelectedList([]);
            getVoteDetails();
            setIsEnable(false);
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "투표 등록 실패. 다시 시도해주세요.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } catch (error) {
        console.error("Error Ending vote:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "투표 종료 오류",
              text: responseData,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    }
  };

  //투표 삭제 버튼
  const deleteVotes = async () => {
    const confirmationResult = await Swal.fire({
      icon: "question",
      title: "투표 삭제",
      text: "투표를 삭제하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (confirmationResult.isConfirmed) {
      try {
        const response = await axios.delete(`${API_SERVER_URL}/${whenMovingNoticeDetail}/delete`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 204) {
          const successResult = await Swal.fire({
            icon: "success",
            title: "성공",
            text: "투표가 삭제되었습니다.",
            confirmButtonText: "확인",
            customClass: {
              popup: "custom-swal-popup",
            },
          });

          if (successResult.isConfirmed) {
            movingNoticePage();
          }
        } else {
          await Swal.fire({
            icon: "error",
            title: "실패",
            text: "삭제 실패. 다시 시도해주세요.",
            confirmButtonText: "확인",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } catch (error) {
        console.error("Error deleting user:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "투표 삭제 오류",
              text: responseData,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    }
  };

  /* 댓글 기능 */
  const { list } = commentState;

  // 댓글 등록
  const commentsAddList = async (content) => {
    try {
      const response = await axios.post(
        `${API_SERVER_URL}` + whenMovingNoticeDetail + "/comment/create",
        {
          comments: content,
          parentId: 0,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 201) {
        //getNoticeDetails();
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "댓글 등록 실패. 다시 시도해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error creating comments: ", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "댓글 등록 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  const commentsUpdateList = (updatedList) => {
    setCommentState((prevState) => ({
      ...prevState,
      list: updatedList,
    }));
  };

  // userSelectedList에서 중복되지 않는 userId 추출
  const uniqueUserIds = Array.from(new Set(userSelectedList.map((user) => user.userId)));
  return (
    <div className="bbs-content-container">
      <div className="bbs-detail-content-option-container-nEditor">
        {modifyButtonText === "수정" ? (
          `${voteInfoData.title}`
        ) : (
          <input type="text" value={voteInfoData.title} onChange={titleChange} name="title" className="vote-title" placeholder="제목을 입력해 주세요." />
        )}
      </div>
      <div className="bbs-detail-content-option-container-regInfo">
        <div className="bbs-detail-regInfo" style={{ display: "flex", flexDirection: "row" }}>
          <span className="text-align-left">
            <span className="span-text-style">작성일&nbsp;</span>
            <span>{bbsDate.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}</span>
          </span>
          <span className="text-align-left">
            <span className="span-text-style">작성자&nbsp;</span>
            <span>{voteInfoData.userId || "임시"}</span>
          </span>
        </div>
      </div>
      <div className={modifyButtonText === "수정" ? "vote-body-container" : "vote-body-container-modify"}>
        {renderVoteSettings()}
        <div className="voting-options">{renderVoteOptions()}</div>
        <div className="vote-button-container">
          {isEnable && modifyButtonText === "수정" && formatDateWbar(new Date()) >= formatDateWbar(new Date(voteInfoData.startDate)) && (
            <>
              <button className="vote-button-baisic-style" onClick={() => vote("투표")}>
                {voteButtonText}
              </button>
              {isUsersVotes && (
                <button className="vote-button-baisic-style" onClick={endedVote}>
                  투표종료
                </button>
              )}
            </>
          )}
          {modifyButtonText === "수정" && totalVoter !== 0 && (
            <button className="vote-button-baisic-style" onClick={movingVisualizationPage}>
              결과보기
            </button>
          )}
        </div>
        {modifyButtonText === "수정" && (
          <div className="vote-left-align">
            <FontAwesomeIcon icon={faUser} />
            &nbsp;<span>{`${totalVoter}명 참여`}</span>
          </div>
        )}
      </div>
      <div className="parent-button-container" style={{ display: "flex", flexDirection: "row" }}>
        <div className="recommend-button-container"></div>
        <div className="notice-detail-button-container">
          {isUsersVotes && (
            <div style={{ display: "flex" }}>
              {isEnable && formatDateWbar(new Date(voteInfoData.startDate)) > formatDateWbar(new Date()) && (
                <button className="warning-button" onClick={modifyNotice}>
                  {modifyButtonText}
                </button>
              )}
              {modifyButtonText === "수정" && (
                <button className="red-button" onClick={deleteVotes}>
                  삭제
                </button>
              )}
            </div>
          )}
          <button onClick={movingNoticePage}>목록</button>
        </div>
      </div>
      {/* <div className='comment-box-container' style={{ display: 'flex', flexDirection: 'column' }}>
            <div className='comments-box'>
                <Comments>
                    <CommentForm onSubmit={(content)=> commentsAddList(content)}/>
                    <CommentList list={list} updatedList={commentsUpdateList} userid={userid} whenMovingNoticeDetail={whenMovingNoticeDetail}/>
                </Comments>
            </div>
        </div> */}
    </div>
  );
}

export default BbsVoteDetail;

// 디바운싱 함수 정의
function debounce(func, flag, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
